import List from 'containers/Comments/List';
import Edit from 'containers/Comments/Edit';
import Create from 'containers/Comments/Create';
import Show from 'containers/Comments/Show';

export default { List, Edit, Create, Show };
